module.exports = __webpack_public_path__ + "img/selectPayTypeIcon.7aa93b48.png";